import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    colorBox:{
        width: 15,
        height: 15,
        borderRadius: theme.shape.borderRadius
    }
}));